import React, { useEffect, useState } from "react";
import styles from "./Credits.module.css";
import BusinessIcon from "@material-ui/icons/Business";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { useDispatch, useSelector } from "react-redux";
import { customerActions } from "@_actions/customer.actions";
import InfoPopup from "@_components/popups/InfoPopup/InfoPopup";
import { Button } from "@material-ui/core";

function Credits() {
  const dispatch = useDispatch();
  const customerReducer = useSelector((state) => state.customerReducer);
  const [openCreditsPopup, setOpenCreditsPopup] = useState(false);

  const handleOpenCreditsPopup = () => {
    setOpenCreditsPopup(true);
  };
  useEffect(() => {
    dispatch(customerActions.getCredits());
  }, [dispatch]);

  return (
    <div className={styles.root}>
      <div className={styles.account_title}>
        <BusinessIcon className={styles.business_icon} />
        <h2>Account </h2>
        <ArrowForwardIosIcon fontSize="small" className={styles.arrow_icon} />
        <h2>Credits</h2>
      </div>
      <div className={styles.credits_container}>
        <p>Balance: {customerReducer.credits}</p>
        <Button className="btn_confirm" onClick={handleOpenCreditsPopup}>
          Add Credits
        </Button>
      </div>
      <InfoPopup
        open={openCreditsPopup}
        title="Credits"
        close={() => setOpenCreditsPopup(false)}
      >
        <p>
          for adding letter sending credit, please send an email with the
          required amount to this address{" "}
          <a href="mailto:support@fairlicensing.com">
            <email>support@fairlicensing.com</email>
          </a>
        </p>
      </InfoPopup>
    </div>
  );
}

export default Credits;
